<template>
  <div>
    <el-form-item label="用户名" prop="username">
      <el-input v-model="data.username" />
    </el-form-item>
    <el-form-item label="手机号" prop="mobile">
      <el-input v-model="data.mobile" />
    </el-form-item>
    <el-form-item
      :rules="[{required:!data.id,message:'请输入密码',trigger:'blur'}]"
      label="密码"
      prop="password"
    >
      <el-input v-model="data.password" show-password></el-input>
    </el-form-item>
    <el-form-item label="性别" prop="gender">
      <el-select v-model="data.gender" placeholder="选择用户性别">
        <el-option v-for="(g,idx) in gender" :key="idx" :value="g.value" :label="g.text"></el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: true,
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data: () => ({
    gender: [
      { text: "保密", value: 0 },
      { text: "男", value: 1 },
      { text: "女", value: 2 }
    ]
  })
};
</script>

<style>
</style>